import { create } from 'zustand';
import { apiClient } from '../lib/api';

/** Employee + personal profile, as returned by the backend (snake_case). */
export interface EmployeeProfile {
  id: string;
  employee_code?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  department?: string;
  designation?: string;
  employment_type?: string;
  status?: string;
  join_date?: string;
  manager_first_name?: string | null;
  manager_last_name?: string | null;
  personal_email?: string | null;
  personal_phone?: string | null;
  date_of_birth?: string | null;
  gender?: string | null;
  marital_status?: string | null;
  blood_group?: string | null;
  nationality?: string | null;
  current_address?: string | null;
  permanent_address?: string | null;
  emergency_contact_name?: string | null;
  emergency_contact_phone?: string | null;
  emergency_contact_relation?: string | null;
}

export interface ImportRowResult { row: number; code: string | null; name: string; action: 'create' | 'update' | 'error'; message?: string }
export interface ImportSummary { total: number; create: number; update: number; errors: number; dryRun: boolean; results: ImportRowResult[] }

const unwrap = (res: any) => res.data?.data ?? res.data;

interface State {
  getSelf: () => Promise<EmployeeProfile>;
  saveSelf: (patch: Record<string, any>) => Promise<EmployeeProfile>;
  getForEmployee: (employeeId: string) => Promise<EmployeeProfile>;
  saveForEmployee: (employeeId: string, patch: Record<string, any>) => Promise<EmployeeProfile>;
  importEmployees: (rows: any[], dryRun: boolean) => Promise<ImportSummary>;
}

export const useProfileStore = create<State>(() => ({
  getSelf: async () => unwrap(await apiClient.get('/people/profile')),
  saveSelf: async (patch) => unwrap(await apiClient.put('/people/profile', patch)),
  getForEmployee: async (employeeId) => unwrap(await apiClient.get(`/people/employees/${employeeId}/profile`)),
  saveForEmployee: async (employeeId, patch) => unwrap(await apiClient.put(`/people/employees/${employeeId}/profile`, patch)),
  importEmployees: async (rows, dryRun) => unwrap(await apiClient.post('/people/employees/import', { rows, dryRun })),
}));
